<template>
  <div class="channels-no-results">
    <h4>{{ $t('tvChannels.notFound.title') }}</h4>
    <p>{{ $t('tvChannels.notFound.description') }}</p>
    <base-button variant="text" @click="$emit('cancel-search')">{{ $t('tvChannels.notFound.cancelSearch') }}</base-button>
  </div>
</template>

<script>
import BaseButton from '../base/base-button'

export default {
  name: 'channels-no-results',
  components: { BaseButton }
}
</script>

<style scoped lang="scss">
.channels-no-results {
  text-align: center;

  h4 {
    font-size: 2.6rem;
    margin-bottom: 2.4rem;
    font-weight: normal;
  }

  p {
    font-size: 1.6rem;
    margin-bottom: 2.4rem;
  }
}
</style>
